import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {FileType} from 'app/models/file-type.enum';
import {MailService} from 'app/services/mail.service';
import {Mail} from 'app/models/mail';
import {ModalPanelComponent} from 'app/shared/components/modal-panel/modal-panel.component';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {GoogleTagManagerService} from '../../../services/google-tag-manager.service';
@Component({
    selector: 'app-modal-share',
    templateUrl: './modal-share.component.html',
    styleUrls: ['./modal-share.component.scss'],
    providers: [MailService]
})
export class ModalShareComponent implements OnInit {

    @ViewChild('modalPanel') modalPanel: ModalPanelComponent;
    @ViewChild('shareForm') shareForm: any;
    @Input() data: any = {};
    icon: string;
    email: string;
    message: string;
    fileType = FileType;
    myform: FormGroup;
    constructor(
      private mailService: MailService,
      private router: Router,
      private gtmService: GoogleTagManagerService,
    ) {}

    ngOnInit() {
        this.myform = new FormGroup({

            email: new FormControl('', [
                Validators.required,
                Validators.pattern(/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)
            ]),
            language: new FormControl()
        });
    }


    share() {
        console.log('Sending', this.email);
        console.log('Sending Data', this.data);
        const mail = new Mail(this.email, this.message);
        if (this.data.sharingType === 'viewer' || this.data.sharingType == 'tile') {

            console.log('url ', this.router.url);
            if (this.router.url.includes('topic') && this.data.source === 'TOPIC') { //we are talking about a real topic and not a topic file
                mail.url = this.router.url;
            } else {

                const urlArr = this.router.url.split('/');

                const id = (this.data.documentId) ? this.data.documentId : this.data.id;
                mail.url = `/${urlArr[1]}/${urlArr[2]}/file/${id}`;
                console.log('calc url', mail.url);
            }

        } else {
            mail.url = this.router.url;
        }
        this.mailService
            .sendMail(this.data.id, mail, 'SHARE')
            .subscribe(
            (result) => {
                // feedback
                this.modalPanel.onClose();
                if (this.data.source === 'TOPIC') {
                  // Changed until new tag plan resolvement
                  this.gtmService.pushEvent(`Share complete - ${this.data.displayName}`);
                } else {
                  this.gtmService.pushEvent(`Share complete - ${this.data.displayName}`);
                }
            },
            (error) => {
                // feedback
                console.log(error);
            }
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/modal-share/modal-share.component.ts